import React from "react";
import { SidebarHeader } from "@src/lib/ui/Sidebar";
import AdminLeftNavNewButton from "@src/features/app/left-nav/admin/AdminLeftNavNewButton";
import LeftNavOrgSwitcher from "@src/features/app/left-nav/LeftNavOrgSwitcher";

const AdminLeftNavOrgAndNewButtons: React.FC = () => {
  return (
    <SidebarHeader className="px-3 pt-4 pb-0 group-data-[collapsible=icon]:px-2 group-data-[collapsible=icon]:pt-4 group-data-[collapsible=icon]:pb-0">
      <div className="flex items-start justify-between gap-1">
        <div className="min-w-0 flex-1">
          <LeftNavOrgSwitcher />
        </div>
        <div className="shrink-0 group-data-[collapsible=icon]:hidden">
          <AdminLeftNavNewButton />
        </div>
      </div>
    </SidebarHeader>
  );
};

export default AdminLeftNavOrgAndNewButtons;
